import { getStore } from 'core_main/store';

export const getChatSettings = () => {
  return getStore().settings;
};
